<mat-card class="cardWithShadow">
    <mat-card-content>
      <div class="table-responsive m-t-30">
        <table mat-table [dataSource]="dataSource" class="w-100">
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="f-w-600 f-s-16 mat-subtitle-1 p-l-0"
            >
              Users
            </th>
            <td mat-cell *matCellDef="let element" class="p-l-0">
              <div class="m-l-12">
                <h5 class="mat-subtitle-1 f-s-14 f-w-600 m-0">
                  {{ element.name }}
                </h5>
                <span class="f-s-12">{{ element.name }}</span>
              </div>
            </td>
          </ng-container>
  
          <!-- Project Name Column -->
          <ng-container matColumnDef="email">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="f-w-600 f-s-16 mat-subtitle-1"
            >
              Email
            </th>
            <td mat-cell *matCellDef="let element" class="f-s-14">
              {{ element.email }}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="rol">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="f-w-600 f-s-16 mat-subtitle-1"
            >
              Roles
            </th>
            <td mat-cell *matCellDef="let element" class="f-s-14">
              {{ element.rol }}
            </td>
          </ng-container>
          <ng-container matColumnDef="rut">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="f-w-600 f-s-16 mat-subtitle-1"
            >
              RUT
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.rut }}
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
  